export default "__VITE_ASSET__I1n5GnSe__"